import { Component, OnInit } from "@angular/core";
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { switchMap } from "rxjs/operators";
import { of } from 'rxjs';
import { Utils } from "src/app/common/utils";
import { DashCred } from "src/app/models/dash";
import { Physician } from "src/app/models/physician";
import { User } from "src/app/models/user";
import { VproService } from "src/app/service/vpro/vpro.service";
import Swal from "sweetalert2";
import { Extend } from "./../../models/extend";
import { ConfirmedValidator } from "../../common/passwordValidator";
import { TextboxField } from "src/app/forms/models/field-textbox";
import { TextareaField } from "src/app/forms/models/field-textarea";
import { DropdownField } from "src/app/forms/models/field-dropdown";
import { DateField } from "src/app/forms/models/field-date";
import { FieldControlService } from "src/app/forms/models/field-control.service";
import { Location } from '@angular/common';
import { invalid } from "moment";
declare var $: any;

@Component({
  selector: "app-doctor-profile",
  templateUrl: "./doctor-profile.component.html",
  styleUrls: ["./doctor-profile.component.css"],
  providers: [FieldControlService],
})
export class DoctorProfileComponent implements OnInit {

  // u_iid = localStorage.getItem('uid');
  // u_id = parseInt(this.u_iid);
  // currentDate = Utils.maxDate;

  // cdt = `${this.currentDate.year}-${this.currentDate.month}-${this.currentDate.day}`;


  // tslint:disable-next-line: no-inferrable-types
  showMore: boolean = false;
  physician = new Physician();
  submitted = false;
  orgdet: any;
  dcred = new DashCred();
  user = new User();
  usereid: string;
  editUser: string;
  dataValue2: any;
  dataValue: any;
  innerHtml: string = "";
  extend = new Extend();
  ppurl: String = "";
  pp_content_type: String = "";
  doctorCurrentTab: string = "personalInformation";
  sp_years = this.utils.getDoctorYears();
  doctorListofTab: any[] = [
    {
      id: "personalInformation",
      title: "Personal Info",
    },
    {
      id: "contactDetails",
      title: "Contact Details",
    },
    {
      id: "speciality",
      title: "Speciality",
    },
    {
      id: "education",
      title: "Education",
    },
    {
      id: "experience",
      title: "experience",
    },
    {
      id: "additionalInformation",
      title: "Additional Information",
    },
  ];
  specialityFormList: number[] = [1];
  educationFormList: number[] = [1];
  experienceFormList: number[] = [1];
  forms = {
    personalInformation: null,
    contactDetails: null,
    speciality: null,
    education: null,
    experience: null,
    additionalInformation: null,
  };
  specialitiesList: any = [];
  physician_speciality: UntypedFormArray;
  physician_education: UntypedFormArray;
  physician_experience: UntypedFormArray;
  ppfile: File = null;
  maxDate = Utils.maxDate;
  states = [];
  countries = [];
  smcs = [];
  hide: boolean = true;
  form_fields = {
    personalInformation: [
      new DropdownField({
        key: "title",
        label: "Title",
        options: of(Utils.TITLE),
        class: "col-12 col-sm-12 col-md-12 col-lg-12",
        required: true,
      }),
      new TextboxField({
        key: "first_name",
        label: "First Name",
        required: true,
        maxlength: 30,
        class: "col-12 col-sm-12 col-md-12 col-lg-12",
        pattern: Utils.alphaSpaceRegex,
      }),
      new TextboxField({
        key: "last_name",
        label: "Last Name",
        required: true,
        type: "text",
        maxlength: 30,
        class: "col-12 col-sm-12 col-md-12 col-lg-12",
        pattern: Utils.alphaSpaceRegex,
      }),
      new TextboxField({
        key: "qualification",
        label: "Qualification",
        required: true,
        maxlength: 30,
        class: "col-12 col-sm-12 col-md-12 col-lg-12",
      }),
      new TextboxField({
        key: "r_no",
        label: "Registration Number",
        required: true,
        maxlength: 30,
        class: "col-12 col-sm-12 col-md-12 col-lg-12",
      }),
      new DropdownField({
        key: "smc",
        label: "State Medical Council",
        options: this.addPhyService.getSmcs(),
        class: "col-12 col-sm-12 col-md-12 col-lg-12",
        required: true,
      }),

      new TextboxField({
        key: "password",
        label: "Password",
        required: true,
        type: "password",
        maxlength: 80,
        class: "col-12 col-sm-12 col-md-12 col-lg-12",
      }),
      new TextboxField({
        key: "cnfrm_password",
        label: "Confirm password",
        required: true,
        type: "password",
        maxlength: 80,
        class: "col-12 col-sm-12 col-md-12 col-lg-12",
      }),

      new DateField({
        key: "dob",
        label: "Date of Birth (DD/MM/YYYY)",
        required: true,
        class: "col-12 col-sm-12 col-md-12 col-lg-12",
        maxDate: Utils.maxDate
      }),
    ],
    contactDetails: [
      new TextboxField({
        key: "address_1",
        label: "Address Line 1",
        maxlength: 150,
        class: "col-12 col-sm-12 col-md-6 col-lg-6",
      }),
      new TextboxField({
        key: "address_2",
        label: "Address Line 2",
        maxlength: 150,
        class: "col-12 col-sm-12 col-md-6 col-lg-6",
      }),
      new TextboxField({
        key: "city",
        label: "City",
        maxlength: 30,
        pattern: Utils.alphaRegex,
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
        required: true,
      }),
      new DropdownField({
        key: "state",
        label: "State",
        options: this.addPhyService.getStates(1),
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
        required: true,
      }),
      new TextboxField({
        key: "zip",
        type: "tel",
        label: "Zip",
        maxlength: 6,
        minlength: 6,
        pattern: Utils.numberRegex,
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
        required: true,
      }),
      new TextboxField({
        key: "contact_no",
        type: "tel",
        label: "Contact No. (App Communications)",
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
        required: true,
        pattern: Utils.numberRegex,
        maxlength: 10,
        minlength: 10,
      }),
      new TextboxField({
        key: "email_id",
        type: "email",
        label: "Email (App Communications)",
        required: true,
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
        maxlength: 50,
        pattern: Utils.emailpat,
      }),
      new TextboxField({
        key: "cnfrm_email_id",
        type: "email",
        label: "Confirm Email (App Communications)",
        required: true,
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
        maxlength: 50,
        pattern: Utils.emailpat,
      }),
      new TextboxField({
        key: "contact_no2",
        type: "tel",
        label: "Contact No. (Visible to public)",
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
        required: false,
        maxlength: 10,
        minlength: 10,
      }),
      new TextboxField({
        key: "email_id2",
        type: "email",
        label: "Email (Visible to public)",
        required: false,
        class: "col-12 col-sm-12 col-md-6 col-lg-6",
        maxlength: 50,
      }),
    ],
    additionalInformation: [
      new TextareaField({
        key: "additional_info",
        label: "Please specify any additional information.",
        minRows: 5,
        class: "col-12 col-sm-12",
      }),
    ],
  };
  // currentDt: Date;


  constructor(
    private addPhyService: VproService,
    private formService: FieldControlService,
    private spinner: NgxSpinnerService,
    private _formBuilder: UntypedFormBuilder,
    private router: Router,
    public utils: Utils,
    private location: Location
  ) {
    for (let form_field in this.form_fields) {
      if (form_field == "personalInformation") {
        this.forms[form_field] = this.formService.toFormGroup(
          this.form_fields[form_field],
          ConfirmedValidator,
          ["password", "cnfrm_password"],

        );
      } else if (form_field == "contactDetails") {
        this.forms[form_field] = this.formService.toFormGroup(
          this.form_fields[form_field],
          ConfirmedValidator,
          ["email_id", "cnfrm_email_id"],

        );
      } else {
        this.forms[form_field] = this.formService.toFormGroup(
          this.form_fields[form_field]
        );
      }
    }

    // for (let form_field in this.form_fields) {
    //   if (form_field == "contactDetails") {
    //     this.forms[form_field] = this.formService.toFormGroup(
    //       this.form_fields[form_field],
    //       ConfirmedValidator,
    //       ["email_id", "cnfrm_email_id"],

    //     );
    //   } else {
    //     this.forms[form_field] = this.formService.toFormGroup(
    //       this.form_fields[form_field]
    //     );
    //   }
    // }


    this.forms.speciality = this._formBuilder.group({
      physician_speciality: this._formBuilder.array([]),
    });

    this.forms.education = this._formBuilder.group({
      physician_education: this._formBuilder.array([]),
    });

    this.forms.experience = this._formBuilder.group({
      physician_experience: this._formBuilder.array([]),
    });
  }
  ngOnInit() {
    this.getOrgDet(localStorage.getItem("LogUsr"));

    //this.currentDt = new Date();



    //   this.extend.org_code = localStorage.getItem('getOrg');

    // render physician specialities list
    this.getSpecialitiesList();
    this.addingSpeciality();
    this.addingMoreEducation();
    this.addingMoreExperience();
    this.loadStates();
    this.loadCountries();
    this.loadSmc();
  }

  loadCountries() {
    this.addPhyService
      .getMasterList("countries")
      .subscribe((res) => (this.countries = res));
  }

  loadSmc() {
    this.addPhyService
      .getMasterList("smc")
      .subscribe((res) => (this.smcs = res));
  }

  createSpeciality(): UntypedFormGroup {
    return this._formBuilder.group({
      speciality_id: ["", [Validators.required]],
      no_of_years: ["", [Validators.required]],
      // createdby: [this.u_id],
      // createdat: [this.currentDt],
      // updatedby: [this.u_id],
      // updatedat: [this.currentDt],
    });
  }

  addEdRecord(): UntypedFormGroup {
    return this._formBuilder.group({
      degree: ["", [Validators.required]],
      institution: ["", [Validators.required]],
      to_year: [null, Validators.pattern(Utils.YearRegex)],
      from_year: [null, Validators.pattern(Utils.YearRegex)],
      country: [null],
      // createdby: [this.u_id],
      // createdat: [this.currentDt],
      // updatedby: [this.u_id],
      // updatedat: [this.currentDt],
    });
  }

  addExperience(): UntypedFormGroup {
    return this._formBuilder.group({
      employer: ["", [Validators.required]],
      designation: ["", [Validators.required]],
      from_year: [null, Validators.pattern(Utils.YearRegex)],
      to_year: [null, Validators.pattern(Utils.YearRegex)],
      country: [null],
      // createdby: [this.u_id],
      // createdat: [this.currentDt],
      // updatedby: [this.u_id],
      // updatedat: [this.currentDt],
    });
  }

  loadStates() {
    this.addPhyService.getStates(1).subscribe((res) => {
      this.states = res;
    });
  }

  async addUser() {
    // console.log(userForm)
    this.submitted = true;
    // Shoot a mail to user

    this.addPhyService.mailUser(this.user).subscribe();

    this.save();
    // SweetAlert
  }
  private save(): void {
    //  console.log(this.user);
    //   console.log(this.user.email_id);
    localStorage.setItem("usethis", this.user.email_id);
    localStorage.setItem("fname", this.user.first_name);
    localStorage.setItem("lname", this.user.last_name);

    this.addPhyService.addUser(this.user).subscribe();
  }

  checkEid() {
    try {
      this.addPhyService.authUser2(this.user).subscribe(
        (data) => {
          this.dataValue2 = data["utype"];

          if (this.dataValue2 !== 8) {
            this.innerHtml =
              "This email-id is already registered with us, please use another !";

            document.getElementById("email_id").focus();
          } else {
            this.innerHtml = "";

            document.getElementById("email_id").blur();
          }
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (excep) {
      console.log(excep);
    }
  }
  getOrgDet(usereid: string) {
    try {
      this.addPhyService.getOrgDet(this.dcred).subscribe(
        (res) => {
          this.orgdet = res;
          for (let i of this.orgdet) {
            this.extend.org_code = i.org_code;
          }
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (excep) {
      console.log(excep);
    }
  }

  show() {
    this.showMore = true;
    this.extend.email = localStorage.getItem("usethis");
    this.extend.altemail = localStorage.getItem("LogUsr");
    this.extend.first_name = localStorage.getItem("fname");
    this.extend.last_name = localStorage.getItem("lname");
  }

  async addExtend() {
    // console.log(userForm)
    this.submitted = true;
    this.save2();

    // SweetAlert

    const Toast = Swal.mixin({
      toast: true,
      position: "top",
      showConfirmButton: false,
      timer: 3500,
    });

    await Toast.fire({
      type: "success",
      title: "Physician profile has been created successfully",
    });
  }

  public save2(): void {
    console.log(this.extend);
    this.addPhyService.addExtend(this.extend).subscribe();
  }
  /** adding more speciality in form list */
  public addingSpeciality(): void {
    this.physician_speciality = this.forms.speciality.get(
      "physician_speciality"
    ) as UntypedFormArray;
    this.physician_speciality.push(this.createSpeciality());
  }
  /** removing current speciality form list */
  public removingCurrentSpeciality(i: number): void {
    this.physician_speciality.removeAt(i);
  }
  /** adding more education in form list */
  public addingMoreEducation(): void {
    this.physician_education = this.forms.education.get(
      "physician_education"
    ) as UntypedFormArray;
    this.physician_education.push(this.addEdRecord());
  }
  /** removing current education form list */
  public removingCurrentEducation(i: number): void {
    this.physician_education.removeAt(i);
  }
  /** adding more experience in form list */
  public addingMoreExperience(): void {
    this.physician_experience = this.forms.experience.get(
      "physician_experience"
    ) as UntypedFormArray;
    this.physician_experience.push(this.addExperience());
  }
  /** removing current experience form list */
  public removingCurrentExperince(i: number): void {
    this.physician_experience.removeAt(i);
  }
  /** opening DatePicker */
  public openDoctorDatePicker() {
    $("#datetimepicker4").datetimepicker();
    alert("called");
  }

  /** assign tabs based on click */
  public doctorAssignTab(tabName: string): void {
    this.doctorCurrentTab = tabName;
  }
  /** next tabs based on next click by user */
  public doctorNextTab(): void {
    let index = this.doctorListofTab.findIndex(
      (t: any) => t.id === this.doctorCurrentTab
    );
    this.doctorCurrentTab = this.doctorListofTab[index + 1].id;
  }
  /** get previous tabname and info */
  public doctorPreviousTab(): void {
    let index = this.doctorListofTab.findIndex(
      (t: any) => t.id === this.doctorCurrentTab
    );
    this.doctorCurrentTab = this.doctorListofTab[index - 1].id;
  }

  get f() {
    return this.forms[this.doctorCurrentTab].controls;
  }

  getSpecialitiesList() {
    this.addPhyService.getSpecialitiesList().subscribe(
      (res) => {
        console.log("specialities list ---------->", res);
        this.specialitiesList = res;
      },
      (error) => {
        console.log("error in getting speciality list", error);
      }
    );
  }

  formValidation(i, key, arrayName) {
    let error = false;
    console.log(" i, key, arrayName", i, key, arrayName);
    console.log("this.doctorCurrentTab", this.doctorCurrentTab);


    if (
      this.forms[this.doctorCurrentTab].get([arrayName]).controls[i] &&
      this.forms[this.doctorCurrentTab].get([arrayName]).controls[i].controls[key] &&
      this.forms[this.doctorCurrentTab].get([arrayName]).controls[i].controls[key].errors
    ) {
      error = true;
    }
    console.log("e", error);
    return error;
  }

  saveDoctor() {
    console.log("inside save doctor");
    let data = {
      ...this.forms.personalInformation.value,
      ...this.forms.contactDetails.value,
      ...this.forms.speciality.value,
      ...this.forms.education.value,
      ...this.forms.experience.value,
      ...this.forms.additionalInformation.value,
      org_code: this.extend.org_code,
    };
    // data.createdby = this.u_id;
    // data.createdat = this.cdt;
    // data.updatedby = this.u_id;
    // data.updatedat = this.cdt;
    if (data.first_name && data.last_name) {
      data.first_name = data.first_name.charAt(0).toUpperCase() + data.first_name.slice(1).toLowerCase();
      data.last_name = data.last_name.charAt(0).toUpperCase() + data.last_name.slice(1).toLowerCase();
    }

    if (data.email_id) {
      data.email_id = data.email_id.toLowerCase();
    }
    if (!data.title) {
      data.title = Utils.DEFAULTDR;
    }

    if (data.dob) {
      data.dob = `${data.dob.year}-${data.dob.month}-${data.dob.day}`;
    }

    if (this.ppurl && this.pp_content_type) {
      data.ppurl = this.ppurl;
      data.pp_content_type = this.pp_content_type;
    }

    delete data.cnfrm_password;
    delete data.cnfrm_email_id;

    data = Utils.removeNullAndEmpty(data);
    console.log("------------------------data is", data);

    this.spinner.show();
    this.addPhyService
      .mailUser({
        user_type: Utils.USER_TYPE.physician,
        email_id: data.email_id,
        password: data.password,
        first_name: this.forms.personalInformation.value.first_name,
        last_name: this.forms.personalInformation.value.last_name,
        account_type: Utils.ALLOWED_TYPE.HEALTHCARE_PROVIDER
      })
      .pipe(switchMap(() => this.addPhyService.addPhysician(data, this.ppfile)))
      .subscribe(
        () => {
          this.spinner.hide();
          // SweetAlert

          const Toast = Swal.mixin({
            toast: true,
            position: "top",
            showConfirmButton: false,
            timer: 3500,
          });

          Toast.fire({
            type: "success",
            title: "Physician profile has been created successfuly",
          });
          this.router.navigate(["/profile"]);
        },
        (error) => {
          this.spinner.hide();
          const Toast = Swal.mixin({
            toast: true,
            position: "top",
            showConfirmButton: false,
            timer: 3500,
          });
          Toast.fire({
            type: "error",
            title: "Something went wrong. Please try again later.",
          });
        }
      );
  }

  public fileSelected(files) {
    if (files[0].type && files[0].type.indexOf('image') === -1) {
      const Toast = Swal.mixin({
        position: 'top',
        showConfirmButton: true,
        allowOutsideClick: false,


      });

      Toast.fire({
        type: 'warning',
        title: 'Only .png/.jpeg/.jpg format is allowed',

      });

    }
    console.log(files);
    if (files && files.length > 0) {
      this.ppfile = files[0];

      this.ppurl = files[0].name;
      this.pp_content_type = files[0].type;
    }
  }
  getback() {
    this.location.back();
  }
}
